const apiKeyProvider = {
  OPENAI_CHATGPT: "OPENAI_CHATGPT",
  OPENAI_GPT3: "OPENAI_GPT3",
  OPENAI_GPT4: "OPENAI_GPT4",
};

export default apiKeyProvider;
